import { render, staticRenderFns } from "./listadoProductosTendero.vue?vue&type=template&id=610e447c&scoped=true&"
import script from "./listadoProductosTendero.vue?vue&type=script&lang=js&"
export * from "./listadoProductosTendero.vue?vue&type=script&lang=js&"
import style0 from "./listadoProductosTendero.vue?vue&type=style&index=0&id=610e447c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e447c",
  null
  
)

export default component.exports